export enum InvitationLinkTypeEnum {
  EVENT = 'EVENT',
  TEAM_EVENT = 'TEAM_EVENT',
  STRUCTURE = 'STRUCTURE',
  FRIEND = 'FRIEND',
}
